import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { API_URL, TOKEN_NAME, REFRESH_TOKEN_NAME } from "../constants";
import StateLoader from "../redux/StateLoader";
import ServiceHelper from "../helper/service.helper";
const stateLoader = new StateLoader();

const login = (username, password) => {
  return axios
    .post(
      `${API_URL}/v1/auth/user-login`,
      ServiceHelper.buildParamsForPOST({ username, password })
    )
    .then((response) => {
      if (response.data.token) {
        localStorage.setItem("user", JSON.stringify(response.data));
        localStorage.setItem(TOKEN_NAME, response.data.token);
      }
      return response.data;
    });
};

const refreshToken = () => {
  const refresh_token = localStorage.getItem(REFRESH_TOKEN_NAME);
  return axios
    .get(`${API_URL}/v1/auth/login/refresh`, {
      headers: { refreshToken: refresh_token },
    })
    .then((response) => {
      return response.data;
    });
};

const authenticateUser = (token) => {
  return axios
    .get(`${API_URL}/v1/auth/profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    });
};

const logout = () => {
  localStorage.clear();
  stateLoader.initializeState();
};

const register = (params, source) => {
  return axios
    .post(`${API_URL}/v1/auth/user`, ServiceHelper.buildParamsForPOST(params), {
      cancelToken: source.token,
    })
    .then((response) => {
      return response.data;
    });
};

const authService = {
  login,
  logout,
  refreshToken,
  register,
  authenticateUser,
};

export default authService;
